import PropTypes from 'prop-types';

const componentServiceShape = PropTypes.shape({
  createInteractiveComponent: PropTypes.func,
  deleteInteractiveComponent: PropTypes.func,
  deleteInteractiveComponents: PropTypes.func,
  restoreInteractiveComponent: PropTypes.func,

  getComponent: PropTypes.func,
  getInComponent: PropTypes.func,
  getInComponentConfig: PropTypes.func,

  saveInComponentConfig: PropTypes.func,
  saveInComponentPreviewScope: PropTypes.func,
  subscribeToComponent: PropTypes.func,
  subscribeToComponentConfig: PropTypes.func,
  receiveComponentChange: PropTypes.func,
});

export default componentServiceShape;
